module.exports = __webpack_public_path__ + "img/21.d9509f32.webp";